function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M1.92152 11.9913V12.4913H2.42152H5.24249L5.10131 13.8895H0.5V0.5H14.8363V8.35779L13.4148 6.98277V2.39826V1.89826H12.9148H2.42152H1.92152V2.39826V11.9913ZM12.9863 14.5621L15.2105 20.6118L13.1169 21.3618L10.8415 15.1762L10.6099 14.5468L10.0728 14.9484L7.31703 17.0085L7.5764 14.4398L7.81855 12.0415L7.81855 12.0414L8.47683 5.51422L12.5672 9.46476L12.5674 9.46502L14.9887 11.8071L14.9889 11.8072L16.8253 13.582L15.3115 13.6583L15.3111 13.6583L13.3823 13.7542L12.7103 13.7877L12.9362 14.4215L12.9846 14.5574L12.9846 14.5574L12.9863 14.5621Z",
  fill: "currentColor",
  stroke: "currentColor"
});
function SvgDisplayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayIcon);
export default __webpack_public_path__ + "static/media/Display Icon.4e02325bc3641468edda28b5797b7ac0.svg";
export { ForwardRef as ReactComponent };